import { BillingPaymentStatus } from "../types/billing";

export const BILLING_PAYMENT_STATUS_DISPLAY_ORDER = [
  BillingPaymentStatus.Overdue,
  BillingPaymentStatus.Unpaid,
  BillingPaymentStatus.Upcoming,
  BillingPaymentStatus.Paid,
];

export const BILLING_PAYMENT_STATUS_PAID_STATUSES = [
  BillingPaymentStatus.Paid,
  BillingPaymentStatus.Upcoming,
];
